import React from "react";
import PropTypes from "prop-types";

import { trackSearchFilterCategoryState } from "@javascript/helpers/searchFilterUtilities";

import Accordion, { AccordionContent, AccordionTrigger } from "@javascript/reactComponents/lds/accordion/Accordion";
import { addSearchCriteriaFilter } from "@javascript/helpers/searchFilterUtilities";
import Chip from "@javascript/reactComponents/lds/chips/Chip";

import Divider from "@javascript/reactComponents/lds/Divider";
import EntitySearchFilterItem from "@javascript/reactComponents/facetSearch/entities/EntitySearchFilterItem";
import Heading from "@javascript/reactComponents/lds/typography/Heading";

import Icon from "@reactComponents/lds/Icon";

export const EntitySearchFilter = createReactClass({
  propTypes: {
    config: PropTypes.shape({
      icon: PropTypes.string.isRequired,
      maxDisplayItems: PropTypes.number,
      showCrmInfo: PropTypes.bool,
      title: PropTypes.string.isRequired,
      tooltip: PropTypes.string.isRequired,
    }).isRequired,
    showTopDivider: PropTypes.bool,
    type: PropTypes.oneOf(['organizations', 'conditions', 'therapies']).isRequired,
  },

  mixins: [Reflux.connectFilter(FacetSearchStore, "items", function(data) {
    return data.facets[this.props.type];
  })],

  getInitialState: function(){
    return {
      displayAll: false,
      items: [],
      open: false,
    }
  },

  openCloseCategory: function (){
    trackSearchFilterCategoryState(!this.state.open, this.props.type);
    this.setState({ open: !this.state.open });
  },

  displayAll: function (event){
    event.preventDefault();
    event.stopPropagation();
    track("user_looked_at_more_facets", "View more facets", {
      facet_type: this.props.type,
    });
    this.setState({ displayAll: true })
  },

  selectFilterItem: function (itemName){
    addSearchCriteriaFilter(this.props.type, itemName);
  },

  render() {
    const { config, showTopDivider, type } = this.props;
    const { icon, maxDisplayItems = 10, showCrmInfo = false, title, tooltip } = config;

    if(!showSelector(this.state.items, type)) {
      return null;
    }

    const trailingAction = (
      <>
        <div className="flex-grow-1" />
        <Chip
          label=""
          leadingIcon={`chevron-${this.state.open ? "up" : "down"}-centered`}
          selected={this.state.open}
          size="small"
          variant={this.state.open ? "primary" : "secondary"}
        />
      </>
    );

    const items = this.state.items.buckets;
    const selectedItems = FacetSearchStore.data.filterCriteria[type] || [];

    const selectedItemsWithHTMLVersions = new Set([
      ...selectedItems,
      ...selectedItems.map(item => escapeHtml(item))
    ]);

    const unselectedItems = items.filter(item =>
      !selectedItemsWithHTMLVersions.has(item.key)
    );

    const exceedsDisplayLimit = unselectedItems.length > maxDisplayItems && !this.state.displayAll;
    const exceedsMaxResults = items.length >= 30;

    const itemsToDisplay = exceedsDisplayLimit
      ? unselectedItems.slice(0, maxDisplayItems)
      : unselectedItems;

    const itemsDisplay = itemsToDisplay.map((item, index) => {
      const { sf_enabled, in_crm, key, doc_count } = item;
      const isSalesforceEnabled = showCrmInfo && sf_enabled;
      const isInSalesforce = showCrmInfo && in_crm;

      const leadingContent = isSalesforceEnabled ? (
        <Icon
          name="salesforce-v2"
          className={isInSalesforce ? "icon-salesforce-v2-lit" : "icon-salesforce-v2-unlit"}
        />
      ) : null;

      const tooltip = isSalesforceEnabled
        ? `${key} is ${isInSalesforce ? '' : 'NOT'} in your Salesforce.`
        : `Click to filter your search to only events involving ${key}.`;

      return (
        <EntitySearchFilterItem
          eventCount={doc_count}
          itemName={key}
          leadingContent={leadingContent}
          key={`${type}_filter_item_${index}`}
          onClick={this.selectFilterItem}
          tooltip={tooltip}
        />
      );
    });

    const renderFooter = () => {
      if (exceedsDisplayLimit) {
        return (
          <p id={`${type}_show_all`} className="type-body-medium">
            <a
              className="lds-text-link show_more_link"
              id={`${type}_more`}
              onClick={this.displayAll}
            >
              Show More
            </a>
          </p>
        );
      } else if (exceedsMaxResults) {
        if (empty_search(search_data())) {
          return (
            <p id={`${type}_showing_30`} className="type-body-medium">
              Showing top 30: try narrowing your search
            </p>
          );
        }
        else {
          return (
            <p id={`${type}_showing_30`} className="type-body-medium">
              <a
                className="lds-text-link"
                id={`create_list_from_${type}_search_filter`}
                onClick={() => createListFromQuery()}
              >
                More than 30... click to create a list
              </a>
            </p>
          );
        }
      }
      return null;
    };

    return (
      <>
        {showTopDivider && <Divider className="facet-search-section-divider" size="small" variant="secondary" />}
        <Accordion
          className="filter_category"
          open={this.state.open}
        >
          <AccordionTrigger onClick={this.openCloseCategory} className="cursor-pointer">
            <Heading
              id={`${type}_search_filter_category_heading`}
              leadingIcon={icon}
              size="h3"
              tooltip={tooltip}
              trailingAction={trailingAction}
            >
              {title}
            </Heading>
          </AccordionTrigger>
          <AccordionContent className="filter_category_inner" gap="var(--filter-category-space-gap)">
            {itemsDisplay.length > 0 ? (
              <>
                {itemsDisplay}
                {renderFooter()}
              </>
            ) : (
              <p className="type-body-medium">All {type} selected.</p>
            )}
          </AccordionContent>
        </Accordion>
      </>
    );
  }
});


EntitySearchFilter.defaultProps = {
  showTopDivider: true,
};

export default EntitySearchFilter;
